import { useState, useEffect } from "react"
import { CollapsibleResourceSection } from "../Components/CollapsibleResourceSection"
import { useSearchParams } from "react-router-dom"
import api from "../services/api"
import Page from "../Components/Page"
import SideBar from "../Components/SideBar"
import { useAtom, useSetAtom } from "jotai"
import { filteredPlansAtom, refetchPlansAtom } from "../state"

function Resources() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [sideBarOpen, setSideBarOpen] = useState(window.innerWidth >= 768)

  const [filteredPlans, setFilteredPlans] = useAtom(filteredPlansAtom)
  const refetchPlans = useSetAtom(refetchPlansAtom)

  useEffect(() => {
    refetchPlans()
  }, [])

  useEffect(() => {
    api.getResources().then(res => {
      setGroups(res.data)
      setLoading(false)
    })
  }, [])

  const onSearchChange = e => setFilteredPlans(e.target.value)

  const onOpenChange = (groupName) => {
    const newSearchParams = new URLSearchParams(searchParams)
    if (newSearchParams.get(groupName) === "true") {
      newSearchParams.delete(groupName)
    } else {
      newSearchParams.append(groupName, "true")
    }
    setSearchParams(newSearchParams)
  }

  return (
    <Page
      sidebar={
        <SideBar
          filteredPlans={filteredPlans}
          onSearchChange={onSearchChange}
          sideBarOpen={sideBarOpen}
          setSideBarOpen={setSideBarOpen}
        />
      }
    >
      <div className="mx-auto max-w-screen-lg px-6 py-12">
        <h1 className="mb-4 text-4xl font-bold text-brandSecondary">Resources</h1>
        <div className="flex flex-col gap-6">
          {loading ? (
            <div className="text-gray-500">Loading...</div>
          ) : (
            groups.map(group => (
              <CollapsibleResourceSection
                key={group.name}
                name={group.name}
                sections={group.sections}
                defaultOpen={searchParams.get(group.name) === "true"}
                onOpenChange={() => onOpenChange(group.name)}
              />
            ))
          )}
        </div>
      </div>
    </Page>
  )
}

export default Resources
